module.exports = __webpack_public_path__ + "static/img/xhsHoverTop.c2f3eb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/footer/xhsHoverTop.png
// module id = JmhO
// module chunks = 12